import { api } from '../../shared/api'
import { tg } from '../../shared/lib/telegram'
import { useList } from '../../shared/lib/useList'
import { Loading } from '../../shared/ui/Loading'
import { EmptyState } from '../../shared/ui/EmptyState'
import { StatusPill } from '../../shared/ui/StatusPill'
import { byDay, time } from '../../shared/lib/format'

export function ScheduleList({ version, refresh }: { version: number; refresh: () => void }) {
  const [rows, error, setError] = useList(() => api.listings(), version)

  const act = async (fn: (id: number) => Promise<unknown>, id: number) => {
    tg?.HapticFeedback?.impactOccurred('light')
    try {
      await fn(id)
      refresh()
    } catch (e) {
      setError((e as Error).message)
    }
  }

  if (error) return <div className="error">{error}</div>
  if (!rows) return <Loading />
  if (rows.length === 0) {
    return (
      <EmptyState title="Пока пусто">
        Заведи товар и поставь время — он выложится сам, без тебя.
      </EmptyState>
    )
  }

  return (
    <>
      {byDay(rows).map(({ label, rows: group }) => (
        <section key={label}>
          <h2 className="group">{label}</h2>
          {group.map((x) => (
            <article className="card" key={x.id}>
              <div className="row">
                <div className="grow">
                  <div className="title">{x.item_title}</div>
                  <div className="sub when">{time(x.publish_at)}</div>
                </div>
                <StatusPill state={x.state} />
              </div>

              {x.error && (
                <div className="sub" style={{ color: 'var(--danger)' }}>
                  {x.error}
                </div>
              )}

              {(x.state === 'planned' || x.avito_draft_id) && (
                <div className="actions">
                  {x.state === 'planned' && (
                    <>
                      <button className="chip accent" onClick={() => act(api.runNow, x.id)}>
                        Выложить сейчас
                      </button>
                      <button className="chip danger" onClick={() => act(api.cancel, x.id)}>
                        Снять
                      </button>
                    </>
                  )}
                  {x.avito_draft_id && (
                    <a
                      className="chip"
                      href={`https://www.avito.ru/additem?draftId=${x.avito_draft_id}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Черновик на Авито
                    </a>
                  )}
                </div>
              )}
            </article>
          ))}
        </section>
      ))}
    </>
  )
}
